import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';

const HeaderSysAdmin = () => (
    <header className="HeaderSysAdmin" role="banner">
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" aria-label="Sys admin header bar with admin navigation">
            <div className="container w-max2">
                <div className="admin-title">
                    <i className="bi bi-person-fill-gear" aria-hidden="true"></i>
                    <span className="spacer-margin2 v-set4">System Administrator</span>
                </div>
                <NavAdmin />
            </div>
        </nav>
    </header>
);

export default HeaderSysAdmin;
